exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-com[data-v-33559f70]{width:100%;height:100%;position:relative}.container-com .del-span[data-v-33559f70]{position:absolute;right:-11px;bottom:-2px;color:#909399;cursor:pointer}.container-com .del-span[data-v-33559f70]:hover{color:#606266}\n", ""]);

// exports
